import * as React from 'react'
import { ShopifyNext } from '@dotdev/next-components'
import { SearchSpring } from '@dotdev/reactive-searchspring'
import { GlobalProps, GlobalState } from 'types'
import * as Layouts from 'layouts'
import * as Snippets from 'snippets'
import * as Sections from 'sections'
import * as Helpers from 'helpers'

export class PrivateCollectionTemplate extends React.Component<
  PrivateCollectionTemplate.Props,
  PrivateCollectionTemplate.State
> {
  constructor(props) {
    super(props)
    this.state = {
      locked: true,
    }
  }
  componentDidMount(): void {
    if (!window) return

    // Get list of pages that have been unlocked from local storage
    const unlockedPages = JSON.parse(window.localStorage.getItem('unlockedPages') ?? '[]')

    // If has been previously unlocked, exit early
    if(unlockedPages.includes(window.location.pathname)) {
      this.setState({ locked: false })
      return
    }

    // If not, check if there is a provided code, and if yes, check that it's right, or exit.
    const searchParams = new URLSearchParams(window.location.search)
    if (!searchParams.has('code')) return

    const { collection } = this.props.data

    const requiredCode = collection.metafields.custom.passcode
    const providedCode = searchParams.get('code')

    if (requiredCode !== providedCode) return

    // If all criteria passed, unlock page and save this page to unlocked pages in future.

    this.setState({
      locked: false,
    })

    unlockedPages.push(window.location.pathname)
    window.localStorage.setItem('unlockedPages', JSON.stringify(unlockedPages))
  }
  public render(): JSX.Element {
    //@ts-ignore
    const collection = {
      ...this.props.data.collection,
      ...this.props.data.section.collection.settings,
    }

    const breadcrumbLinks = [
      {
        title: 'Home',
        name: 'Home',
        url: '/',
      },
      {
        title: collection.title,
        name: collection.title,
        url: collection.url,
      },
    ]

    const breadcrumbProps = {
      ...this.props,
      breadcrumbs: {
        divider: '/',
        links: breadcrumbLinks,
      },
    }

    return (
      <Layouts.Theme {...this.props}>
        {this.state.locked ? <div className="fixed top-0 bottom-0 right-0 left-0 backdrop-blur z-30 flex p-4 items-center justify-center">
          <div className="flex flex-col gap-4 bg-white p-2 text-center">
            <Snippets.Heading tag="h3">
              This collection is private.
            </Snippets.Heading>
            <Snippets.Button colour="secondary-transparent" href="/" title="Go Home">Go Home</Snippets.Button>
          </div>
        </div> : null}
        <section
          className={'max-w-container mx-auto px-3-2 py-2-5 lg:block hidden'}
        >
          <div className={'flex'}>
            <div className={'md:w-1/2'}>
              <Snippets.Breadcrumbs {...breadcrumbProps} />
            </div>
          </div>
        </section>

        <div>
          <SearchSpring.Component.Provider
            searchspringOptions={{
              siteId: SEARCHSPRING_ID,
              querystring: true,
              query: collection.id
                ? {
                  bgFilters: {
                    collection_id: collection.id,
                  },
                }
                : null,
            }}
          >
            {collection ? <Snippets.CollectionTitle {...this.props} /> : null}
            <Sections.ProductResults {...this.props} collection={collection} />
            {collection ? <Snippets.CollectionSEO {...this.props} /> : null}
          </SearchSpring.Component.Provider>
          {this.props.sections.length > 0 ? (
            <ShopifyNext.Components.DynamicSections {...this.props} />
          ) : null}
        </div>
      </Layouts.Theme>
    )
  }
}

declare const SEARCHSPRING_ID: string

export namespace PrivateCollectionTemplate {
  export interface Props extends GlobalProps {}
  export interface State extends GlobalState {
    locked: boolean;
  }
}
